module.exports = __webpack_public_path__ + "static/media/sara1.bc1d12d0.png";